export const changeDimensions = (height, width) => (
  { type: 'CHANGE_DIMENSIONS', height, width }
);
